import {
  isMobile,
  isTablet,
  isDesktop,
  osName,
  osVersion,
  browserName,
  browserVersion,
  mobileVendor,
  mobileModel,
} from 'react-device-detect';

// Device/browser fingerprint sent to the insurer backends alongside inspection requests.
// The public IP is intentionally absent: the browser cannot read it, so the backend takes
// it from the request instead (X-Forwarded-For / remote address).

const deviceType = isMobile ? 'Mobile' : isTablet ? 'Tablet' : isDesktop ? 'Desktop' : 'Unknown';

const screenInfo = () => {
  if (typeof window === 'undefined' || !window.screen) return 'N/A';
  const { width, height } = window.screen;
  return `${width}x${height}@${window.devicePixelRatio || 1}`;
};

const timezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'N/A';
  } catch (e) {
    return 'N/A';
  }
};

// Static parts are resolved once: react-device-detect and screen metrics do not change
// during a session.
const staticInfo = {
  device_type: deviceType,
  os: `${osName} ${osVersion}`,
  browser: `${browserName} ${browserVersion}`,
  vendor: mobileVendor || 'N/A',
  model: mobileModel || 'N/A',
  screen: screenInfo(),
  language: (typeof navigator !== 'undefined' && navigator.language) || 'N/A',
  timezone: timezone(),
  user_agent: (typeof navigator !== 'undefined' && navigator.userAgent) || 'N/A',
};

export const getDeviceInfo = () => ({
  ...staticInfo,
  time: new Date().toLocaleString('vi-VN'),
});

// Serialized form expected by the `divide_logs` request parameter.
export const getDeviceLogs = () => JSON.stringify(getDeviceInfo());
